import React from 'react';
import {BuildingComponentsFormType} from "../../packages/web/components-types/src/forms";

const BuildingComponentsContext = React.createContext<BuildingComponentsFormType>({} as any);

export default BuildingComponentsContext;
